import { CERTIFICATE_BASE_PATH_KEY } from '@cplug/frontend-subscription-hub/domain/certificate'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(CERTIFICATE_BASE_PATH_KEY, '/dashboard/settings/certificate')
})
